import { useQueryParamValue } from 'src/app/shared/hooks/location';

export const usePageBody = () => {
	const selectedTab = useQueryParamValue('tab') || 'edit';

	return {
		data: {
			selectedTab,
		},
	};
};
